
import CryptoJS from 'crypto-js'; // Import the crypto module

  export function encrypt(text) {
    const password = 'password'; // Replace with a secure key
    const encrypted = CryptoJS.AES.encrypt(text, password).toString();
    return encrypted;
  }

  export function decrypt(text) {
    const password = 'password'; // Replace with a secure key
    const bytes = CryptoJS.AES.decrypt(text, password);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  }